module.exports = require("pako/lib/inflate");